<template>
  <div class="checkbox" @click.stop.prevent="toggle">
    <div class="wrapper">
      <input type="checkbox" :id="id" :checked="localValue" tabindex="-1" @click.prevent.stop />

      <icon class="icon active" v-show="localValue" name="check_box" />

      <icon class="icon" v-show="!localValue" name="check_box_outline_blank" />
    </div>

    <label v-if="label" @click.stop.prevent="toggle">
      {{ label }}
    </label>
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    value: Boolean,
    id: String,
    label: String,
  },

  data() {
    return {
      localValue: this.value || false,
    };
  },

  watch: {
    value(value) {
      const next = value || false;
      if (this.localValue !== next) {
        this.localValue = next;
      }
    },
  },

  methods: {
    toggle() {
      const next = !this.localValue;
      this.localValue = next;
      this.$emit('input', next);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.checkbox {
  margin-bottom: var(--checkbox-margin-bottom, $gp);
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.wrapper {
  display: inline-flex;
  align-items: center;
}

label {
  margin-left: $gp * .25;
  cursor: pointer;
}

.icon {
  font-size: 32px;
  color: var(--theme-color);

  &:active,
  &.active {
    color: $color-green-1;
  }
}

input {
  position: absolute;
  left: -999em;
  pointer-events: none;
}
</style>
